import { useCallback, useState } from "react"
import styled from "styled-components"
import check from "@/lib/assets/check_red.png"

export const useCheckBox = (props: {
    defaultValue?: boolean
    onClick?: (value: boolean) => void
}) => {
    const [checked, setChecked] = useState(props.defaultValue || false)

    const onChange = useCallback((value: boolean) => {
        setChecked(value)
        props.onClick?.(value)
    }, [props])

    const component = (
        <CheckBoxStyle>
             <div className="checks" onClick={() => { onChange(!checked) }}>
                <div className="check"></div>
                {checked ? <img className="icon" src={check} alt="check" /> : <></>}
            </div>
        </CheckBoxStyle>
    )

    return {
        component,
    }
}

const CheckBoxStyle = styled.div`
    .checks {
        position: relative;
        display: flex;
        align-items: center;
        height: 40px;
        width: 40px;
        text-align: center;
        margin: auto;
        cursor: pointer;
        .check {
            background-color: white;
            width: 30px;
            height: 30px;
            margin: auto;
        }
        .icon {
            position: absolute;
            width: 40px;
            height: 40px;
        }
    }
`
